import { CardAlumno } from "./../Alumnos/CardAlumno"

// import ALUMNOS from '../../Json/ALUMNOS.json'


export const AlumnosRelacionados = (params) => {
    // Obtener estudiantes filtrados por línea de investigación
    const filteredStudents = (params.students || []).filter((student) => {
        // Filtrar por línea de investigación (usar nombre de línea o icon_inv como fallback)
        const matchesLinea = student.linea_investigacion === params.linea || 
                            student.icon_inv === params.icon_inv;
        
        // Solo mostrar estudiantes habilitados
        return matchesLinea && student.habilitado !== false;
    });

    if (filteredStudents.length === 0) {
        return null;
    }

    return(
        <article className='container'>
        <h2>Alumnos involucrados</h2>
        <hr />
            <div className="row gap-5 alumnos-linea-row">
                    {
                        filteredStudents.map((student, idx) => {
                                return(
                                <div key={student.id || student.name || idx} className="col-md-5 d-flex">
                                    <CardAlumno  
                                        idx={idx} 
                                        student={student} 
                                        isLineaCard={true}
                                        {...params}
                                    ></CardAlumno>
                                    </div>
                                )
                        })
                    }
            </div>
    </article>
    )
}